import { useDispatch, useSelector } from 'react-redux';
// Définition des fonctions useSelector et useDispatch adaptées à TypeScript
export const useAppDispatch = useDispatch;
export const useAppSelector = useSelector;
